var _g, _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMarkRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1773_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.00024C19.7467 3.00024 24 7.25354 24 12.5002V12.5002C24 17.7469 19.7467 22.0002 14.5 22.0002V22.0002C9.25329 22.0002 5 17.7469 5 12.5002V12.5002C5 7.25354 9.25329 3.00024 14.5 3.00024V3.00024Z",
    stroke: "#DC4C4C",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.237 8.10681C13.2357 8.093 13.2351 8.0861 13.2345 8.08121C13.234 8.07633 13.232 8.06051 13.2279 8.02886C13.1934 7.75982 13.0505 6.16724 14.5 6.16724C15.9496 6.16724 15.8066 7.75982 15.7721 8.02886C15.7681 8.06051 15.7661 8.07633 15.7655 8.08121C15.765 8.0861 15.7644 8.093 15.7631 8.10681L15.1686 14.6459C15.1519 14.8302 15.1435 14.9223 15.0824 14.9781C15.0213 15.0339 14.9288 15.0339 14.7437 15.0339H14.2563C14.0713 15.0339 13.9788 15.0339 13.9177 14.9781C13.8566 14.9223 13.8482 14.8302 13.8314 14.6459L13.237 8.10681Z",
    fill: "#DC4C4C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 17.5672,
    r: 0.633333,
    fill: "#DC4C4C",
    stroke: "#DC4C4C",
    strokeWidth: 0.533333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1773_63",
    x: 0.233333,
    y: 0.366911,
    width: 28.5333,
    height: 28.5333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.13333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1773_63"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1773_63",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkRed);
export default __webpack_public_path__ + "static/media/exclamation-mark-red.3b7e3e2126d1de5e7c373f1fc3adbaea.svg";
export { ForwardRef as ReactComponent };